import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router'
import { Injectable } from '@angular/core'
import { BuilderService } from '../builder-services/builder.service'
import { LoginService } from '../login/login.service'

@Injectable({
  providedIn: 'root'
})
export class cancelledUserGuard implements CanActivate {
  constructor(
    private builderService: BuilderService,
    private router: Router,
    private loginService: LoginService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const projectId = this.builderService.selectedProject
    if (!projectId) {
      this.router.navigate(['/'])
      return false
    }

    if (this.loginService.getCurrentUser().admin) {
      return true
    }

    // Cancelled subscription = free plan access.
    // stacks-chat owns the cancelled-state UI; builder just lets the user through.
    return true
  }
}
